export default {
  // 404 Page
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back to Dashboard',

  // Login Page
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.submit': 'Login',

  // Welcome Page
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy components have been released.',

  // Common
  'pages.searchTable.new': 'New',
  'pages.searchTable.config': 'Config',
  'pages.searchTable.title': 'Search Table',
  'pages.searchTable.titleOption': 'Actions',
  'pages.searchTable.batchDeletion': 'Batch Delete',
  'pages.searchTable.chosen': 'Selected',
  'pages.searchTable.item': 'items',

  // Form
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule Configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least 5 characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter at least 5 characters for rule description!',

  // Status
  'pages.searchTable.nameStatus.default': 'Disabled',
  'pages.searchTable.nameStatus.running': 'Running',
  'pages.searchTable.nameStatus.online': 'Online',
  'pages.searchTable.nameStatus.abnormal': 'Abnormal',
};
